import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar";
import Dropdown from "./Dropdown";

export default function InvestRisk({ user }) {
    const navigate = useNavigate();

    const goNext = () => {
        navigate("/InvestFactors");
    };

    const goPrev = () => {
        navigate("/InvestDef");
    };

    return (
        <div className="h-screen overflow-hidden">
            <Navbar user={user} />
            <Dropdown />
            <div className="w-full flex flex-col justify-center items-center overflow-hidden">
                <div className="text-[#000000] text-5xl m-4 font-bold">
                    Risk
                </div>
                <span className="w-full h-0.5 bg-blueInFigma"></span>
                <div className="text-[#000000] text-3xl mt-4">
                    Risk is the amount of uncertainty that an investment will lead to a greater 
                </div>
                <div className="text-[#000000] text-3xl">
                    return.  It can also be described as the potential an investment has to lead to a 
                </div>
                <div className="text-[#000000] text-3xl">
                    financial loss.  Every investment comes with an associated risk.  Some investments 
                </div>
                <div className="text-[#000000] text-3xl">
                    have low risk, like putting money in a savings account.  Other investments have a 
                </div>
                <div className="text-[#000000] text-3xl  ">
                    generally high risk, like investing money into stocks.  Learning how to balance risk 
                </div>
                <div className="text-[#000000] text-3xl  ">
                    and investment is a very valuable skill.
                </div>
            </div>
            <button className="bg-[#73C4FC] text-[#FFFFFF] p-4 absolute bottom-[10%] right-[17.5%] text-3xl rounded-2xl"
                onClick={goNext}
            >
                Next
            </button>
            <button className="bg-blueInFigma text-[#FFFFFF] p-4 absolute bottom-[10%] left-[17.5%] text-3xl rounded-2xl"
                onClick={goPrev}
            >
                Prev
            </button>
        </div>
    );
}